import clsx from 'clsx';
import {Icon} from '@rmwc/icon';
import type {IconProps} from './Icon.types';
import React from 'react';

export const createIcon =
  (ligature: string, initialProps?: React.ComponentPropsWithRef<typeof Icon>) =>
  (templateProps: IconProps) => (
    <Icon
      {...initialProps}
      {...templateProps}
      className={clsx(templateProps.className, initialProps?.className)}
      icon={{icon: ligature, size: templateProps.fontSize}}
    />
  );
export const createOutlined = (ligature: string) =>
  createIcon(ligature, {className: 'material-icons-outlined'});

export const createRounded = (ligature: string) =>
  createIcon(ligature, {className: 'material-icons-rounded'});
